__turbopack_context__.v({
  "buttonContainer": "bcKZ6W_buttonContainer",
  "container": "bcKZ6W_container",
  "instructions": "bcKZ6W_instructions",
  "saveButton": "bcKZ6W_saveButton",
  "sliderContainer": "bcKZ6W_sliderContainer",
});
